export enum HeatingTypesEnum {
  ELECTRIC = 'Chauffage électrique',
  OIL = 'Chauffage à mazout',
  GAS = 'Chauffage au gaz',
  PELLET = 'Chauffage à pellets',
  WOOD = 'Chauffage au bois',
  OTHER = 'Autre'
}
